import baseService from './baseService';

export function industryCreation(data) {
  return baseService.post('/industries', {
    name: data,
  });
}
